<div class="st-body template-standard">
  <div class="container">
    <div class="template_st">

      <!-- Dynamic template name badge -->
      <div class="st-type-badge">{{ templateName }}</div>

      <!-- Cover + photo -->
      <header class="st-cover">
        <div class="st-avatar">
          <img [src]="imageSrc" alt="profileImage" />
        </div>
      </header>

      <!-- Name -->
      <section class="st-name">
        <h1>{{ firstName + ' ' + lastName }}</h1>
        <p class="st-job">{{ jobTitle }}</p>
        <p class="st-company" *ngIf="companyName">{{ companyName }}</p>
      </section>

      <section class="st-contact">
        <a [href]="'tel:' + phone" class="st-c-tel"><i class="fa-solid fa-phone"></i><span>Call</span></a>
        <a [href]="'sms:' + phone" *ngIf="phoneAllow" class="st-c-sms"><i class="fa-solid fa-comments"></i><span>Text</span></a>
        <a [href]="'mailto:' + email" class="st-c-mail"><i class="fa-solid fa-envelope"></i><span>Email</span></a>
        <a [href]="'https://www.google.com/maps?q=' + address" target="_blank" class="st-c-map" *ngIf="address"><i class="fa-solid fa-location-dot"></i><span>Map</span></a>
      </section>

      <!-- About -->
      <section class="st-about" *ngIf="content" [innerHTML]="content"></section>

      <div class="st-facts" *ngIf="gpa || school || grade || height || age || weight">
        <span *ngIf="gpa"><b>GPA</b> {{ gpa }}</span>
        <span *ngIf="school"><b>School</b> {{ school }}</span>
        <span *ngIf="grade"><b>Grade</b> {{ grade }}</span>
        <span *ngIf="height"><b>Height</b> {{ height }}</span>
        <span *ngIf="age"><b>Age</b> {{ age }}</span>
        <span *ngIf="weight"><b>Weight</b> {{ weight }}</span>
      </div>

      <section class="st-links" *ngIf="buttons && buttons.length > 0 && buttons[0].LinkButtonTitle">
        <ng-container *ngFor="let button of buttons">
          <a class="st-link" *ngIf="button" [href]="button.LinkButtonLink" target="_blank" [style.background-color]="buttonColor">
            <i class="fa-solid fa-link"></i><span>{{ button.LinkButtonTitle }}</span><i class="st-go fa-solid fa-chevron-right"></i>
          </a>
        </ng-container>
      </section>

      <section class="st-social" *ngIf="instagram || youtube || facebook || twitter || linkedin || pinterest">
        <a [href]="instagram" target="_blank" *ngIf="instagram" class="st-s-instagram"><i class="fa-brands fa-instagram"></i></a>
        <a [href]="youtube" target="_blank" *ngIf="youtube" class="st-s-youtube"><i class="fa-brands fa-youtube"></i></a>
        <a [href]="facebook" target="_blank" *ngIf="facebook" class="st-s-facebook"><i class="fa-brands fa-facebook-f"></i></a>
        <a [href]="twitter" target="_blank" *ngIf="twitter" class="st-s-twitter"><i class="fa-brands fa-twitter"></i></a>
        <a [href]="linkedin" target="_blank" *ngIf="linkedin" class="st-s-linkedin"><i class="fa-brands fa-linkedin-in"></i></a>
        <a [href]="pinterest" target="_blank" *ngIf="pinterest" class="st-s-pinterest"><i class="fa-brands fa-pinterest-p"></i></a>
      </section>

      <section class="st-gallery" *ngIf="productImages">
        <img *ngFor="let img of productImages; trackBy: trackByIndex" [src]="img" alt="productImage" />
      </section>

      <div class="st-logo">
        <img *ngIf="logo != null" [src]="imageSrcLogo" alt="logoimage" />
        <img *ngIf="logo == null" src="assets/images/unmasking-yourself.jpg" alt="logoimage" />
      </div>

      <!-- VIDEOS: YouTube + Umyotube (YouTube / Dailymotion / umyovideo) + Vimeo -->
      <section class="st-videos">
        <div class="st-sec-title" *ngIf="(youtubeArray && youtubeArray.length > 0 && youtubeArray[0].youtubeLink) || (vimeoArray && vimeoArray.length > 0 && vimeoArray[0].vimeoVideoLink) || (umyotubeArray && umyotubeArray.length > 0 && umyotubeArray[0].umyotubeLink)">
          <i class="fa-solid fa-circle-play"></i> Videos
        </div>

        <ng-container *ngFor="let v of youtubeArray">
          <div class="st-video" *ngIf="v.youtubeLink | videoEmbed as src">
            <p class="st-video-title"><i class="fa-brands fa-youtube"></i> {{ v.youtubeTitle }}</p>
            <div class="st-embed">
              <iframe [src]="src" [title]="v.youtubeTitle || 'YouTube player'" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>
        </ng-container>

        <ng-container *ngFor="let v of umyotubeArray">
          <div class="st-video" *ngIf="v.umyotubeLink | videoEmbed as src">
            <p class="st-video-title"><i class="fa-solid fa-circle-play"></i> {{ v.umyotubeTitle }}</p>
            <div class="st-embed">
              <iframe [src]="src" title="Umyotube player" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </ng-container>

        <ng-container *ngFor="let v of vimeoArray">
          <div class="st-video" *ngIf="v.vimeoVideoLink | videoEmbed as src">
            <p class="st-video-title"><i class="fa-brands fa-vimeo-v"></i> {{ v.vimeoVideoTitle }}</p>
            <div class="st-embed">
              <iframe [src]="src" [title]="v.vimeoVideoTitle || 'Vimeo player'" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </ng-container>
      </section>

      <div class="st-ctrls">
        <button type="button" class="ctrl-item" *ngIf="forwardCard" data-bs-toggle="modal" data-bs-target="#shareCard">
          <i class="fa-solid fa-share"></i><h3>Forward</h3>
        </button>
        <a (click)="navigateToHome()" type="button" class="ctrl-item">
          <i class="fa-solid fa-right-to-bracket"></i><h3>Sign Up</h3>
        </a>
        <button type="button" class="ctrl-item" *ngIf="saveCard" (click)="downloadVCard()">
          <i class="fa-solid fa-download"></i><h3>Save My Card</h3>
        </button>
      </div>

      <footer class="st-footer">
        <img class="st-qr" *ngIf="qrCodeImage" [src]="qrCodeImage" alt="QR Code" />
        <p class="st-strip">Share <i></i> Connect <i></i> Grow</p>
        <p class="st-powered">This card is powered by <span>UMYO Cards</span></p>
        <form action="" class="referal-form" *ngIf="inviteCode">
          <label for="referal">Referral ID: </label>
          <input type="text" name="referal" id="referal" [value]="referal" disabled placeholder="XXXXX" />
        </form>
        <a [routerLink]="['/']" class="call-to-action">
          <span class="left">Click<br />Here</span>
          <span class="right">Design your card now!</span>
        </a>
      </footer>

    </div>
  </div>
</div>